import React, { useEffect } from 'react'

import Form from '@/components/Form'
import { Button } from '@/components/UiElements'

import ruleFormItems from '../forms/ruleFormItems'





export default function RuleForm(props: any) {

	//console.log('props', props)
	const rowsRef = React.useRef<number[]>([])
	const formRefs = React.useRef<Record<number, any>>({})
	const formDataRef = React.useRef<Record<number, Record<string, any>>>({})
	const rowTierRef = React.useRef<Record<number, number>>({})
	//const [hasValidationError, setHasValidationError] = React.useState(false)
	const [, forceRender] = React.useState(0)
	const divRef = React.useRef<HTMLDivElement>(null)




	const handleAddRule = () => {
		const prev = rowsRef.current
		const maxId = prev.length > 0 ? Math.max(...prev) : 0
		const newId = maxId + 1

		const maxTier = Object.values(formDataRef.current).reduce((max, data) => {
			const t = Number(data?.tier ?? 0)
			return t > max ? t : max
		}, 0)

		const newTier = maxTier + 1

		rowsRef.current = [...prev, newId]
		rowTierRef.current[newId] = newTier
		formDataRef.current[newId] = {
			tier: newTier,
			delete: (props: any, data: any) => {
				handleRemoveRule(props, data, newId)
			},
		}


		forceRender(v => v + 1)
		updateRowHeight()
		handleUpdateFormData()
	}



	const handleRemoveRule = (props: any, data: any, rowId: number) => {
		console.log(rowId)
		if (rowId  !== rowsRef.current.length) return


		rowsRef.current = rowsRef.current.filter(id => id !== rowId)
		console.log(rowsRef.current.length, rowId)


		delete formRefs.current[rowId]
		delete formDataRef.current[rowId]
		delete rowTierRef.current[rowId]
		forceRender(v => v + 1)
		updateRowHeight()
		handleUpdateFormData()
	}







	const handleUpdateFormData = () => {
		props.onChange(props.formItem.name, Object.values(formDataRef.current))
		props.onChange("rulesList", Object.values(formDataRef.current))
		if (props.validation) {
			Object.keys(formRefs.current).map(key=>{
				const id = Number(key)
				const data = formDataRef.current[id]
				formRefs.current[id]?.validate(false, data)
			})
		}

	}


	const updateRowHeight = () => {
		if (divRef.current) {
			divRef.current.style.height = (rowsRef.current.length * (105-29)) + 71 + 29  + 'px'
		}
	}


	useEffect(() => {
		const rules = props.formData?.rulesList;
		if (!rules || !Array.isArray(rules) || rowsRef.current.length) return;

		// reset refs
		rowsRef.current = [];
		formRefs.current = {};
		formDataRef.current = {};
		rowTierRef.current = {};

		if (!rules.length) return
		rules.forEach((rule: any, index: number) => {
			const id = index + 1;
			rowsRef.current.push(id);

			rowTierRef.current[id] = rule.tier ?? id;

			formDataRef.current[id] = {
				tier: rule.tier,
				value: rule.value,
				price_rule: {value:
						rule.price_rule.value ? rule.price_rule.value : rule.price_rule?.toUpperCase()},
				delete: (props: any, data: any) => {
					handleRemoveRule(props, data, id)
				}
			}
		});

		forceRender(v => v + 1);
		updateRowHeight();
		handleUpdateFormData();
	}, [props.formData?.rulesList]);


	return (
		<div ref={divRef} id={"formRuleRows"} className={`flex flex-col gap-xl ${props.validation ? "bg-red-100" : "bg-gray-100"} rounded-md p-md transition-all duration-500 overflow-hidden`}>
			<style>
				${`
					#formRuleRows > div:nth-child(n+3) {
						background:#ff0000
					}
					#formRuleRows > div:nth-child(n+3) .FormContainerLabel {
						display: none !important; 
						opacity: 0;
					}
					#formRuleRows > div button {
						display: none !important; 
					}
					#formRuleRows > div:nth-last-child(2) button, #formRuleRows > div:nth-last-child(1) button {
						display: flex !important; 
					}
				`}

			</style>
			{rowsRef.current.map((rowId, index) => (
				<div className="grid grid-cols-12 gap-md" key={rowId} >
					<Form
						ref={el => {
							if (el) formRefs.current[rowId] = el
						}}
						items={ruleFormItems}
						defaultValues={formDataRef.current?.[rowId] || {
							tier: `${rowTierRef.current[rowId]}`,
							delete: (props: any, data: any) => {
								console.log(props, rowId, data)
								handleRemoveRule(props, data, rowId)
							}
						}}
						onChange={(formData: Record<string, any>) => {
							formDataRef.current[rowId] = formData
							handleUpdateFormData()
						}}
					/>
				</div>
			))}

			<div>
				<Button
					size="sm"
					type="alt"
					className="pr-lg col-span-2 w-[123px]"
					icon="+"
					onClick={handleAddRule}
				>
					Add Rule
				</Button>
			</div>
		</div>
	)
}